import { Flex } from 'foundations-components/components/Flex';
import { usePaymentFormContext } from '../../context/PaymentFormContext';
import PostalCodeInput from './PostalCodeInput';
import CountryInput from './CountryInput';
import useWindowSize from '../../hooks/useWindowSize';
import { ROW_BREAKPOINT } from '../../constants/Sizes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BasicAddress = ({
  postalCode,
  country,
  onChange
}) => {
  const {
    formState
  } = usePaymentFormContext();
  const disabled = formState.get('isCheckoutSubmitPending');
  const {
    width
  } = useWindowSize();
  const isRow = width >= ROW_BREAKPOINT;
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: isRow ? 'row' : 'column',
    gap: "200",
    inlineSize: "100%",
    children: [/*#__PURE__*/_jsx(Flex, {
      flexBasis: "50%",
      children: /*#__PURE__*/_jsx(CountryInput, {
        formControlProps: {
          inlineSize: '100%'
        },
        value: country,
        onChange: event => onChange('country', event),
        disabled: disabled
      })
    }), /*#__PURE__*/_jsx(Flex, {
      flexBasis: "50%",
      children: /*#__PURE__*/_jsx(PostalCodeInput, {
        formControlProps: {
          inlineSize: '100%'
        },
        value: postalCode,
        onChange: event => onChange('postalCode', event),
        disabled: disabled
      })
    })]
  });
};
export default BasicAddress;